import React, { useEffect } from 'react';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../styles/button-styles';
import ViewWrapperWithCommandBar from '../Common/Layout/ViewWrapperWithCommandBar';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import {
  Text,
  DefaultPalette,
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  ChoiceGroup,
  IChoiceGroupOption,
  IDetailsListProps,
  DetailsRow,
  Icon,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';

import { useNavigate } from 'react-router-dom';
import { routes } from '../../common/routes';
import SystemClient from '../../system/SystemClient';
import MessageCourier from '../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import { DefaultButton, Label, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import PlanillaPartidoForm from '../PlanillaPartido/PlanillaPartidoForm';
import { useCustomInput } from '../../common/custom-hooks/useCustomInput';
import ConfeccionPlanillaPartidoView from '../PlanillaPartido/Programado/Confeccion/ConfeccionPlanillaPartidoView';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { PlanillaPartidoContext } from '../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Jugador } from '../../system/Jugador/Jugador';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import PlanillaDigitalForm, { ROL_JUGADOR } from './PlanillaDigitalForm';
import {
  GOL,
  TARJETA_AMARILLA,
  DOS_MINUTOS,
  TARJETA_ROJA,
  TARJETA_AZUL,
} from '../../system/TipoEventoPlanilla/TipoEventoPlanilla';
import { EventoXPlanilla } from '../../system/EventoXPlanilla/EventoXPlanilla';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';
import PlanillaDigitalTimer from './PlanillaDigitalTimer';

interface IPlanillaDigitalJugadoresGrid {
  jugadoresForList: any[]; // todocambiar a interface
  addEventForJugador: (ppjId: number) => void;
  color: any;
  getMinuto: () => string;
  form: PlanillaDigitalForm;
  esDiferido: boolean;
  onRefereeReview: boolean;
}

const PlanillaDigitalJugadoresGrid = ({
  jugadoresForList,
  addEventForJugador,
  color,
  getMinuto,
  form,
  esDiferido,
  ...props
}: IPlanillaDigitalJugadoresGrid) => {
  const [errorGoles, setErrorGoles] = React.useState(false);
  const [errorAmarillas, setErrorAmarillas] = React.useState(false);
  const [errorSuspensiones, setErrorSuspensiones] = React.useState(false);
  const [errorRojas, setErrorRojas] = React.useState(false);
  const [errorAzules, setErrorAzules] = React.useState(false);

  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        {jugadoresForList.map((j) => {
          return (
            <div
              className="ms-Grid-col ms-lg4 ms-xl3 mt-1"
              onClick={() => addEventForJugador(j.ppj_id)}
              style={{ position: 'relative' }}
            >
              <div>
                <div className="tarjeta-roja">
                  {j.rojas > 0 && (
                    <div>
                      {!errorRojas ? (
                        <Image
                          src={'/img/tarjeta_roja.png'}
                          imageFit={ImageFit.cover}
                          onError={() => {
                            setErrorRojas(true);
                          }}
                          styles={{
                            root: {
                              width: '12px',
                              height: '14px',
                              display: 'inline-block',
                              marginRight: '3px',
                            },
                          }}
                        ></Image>
                      ) : (
                        <Text variant="small">TR</Text>
                      )}
                    </div>
                  )}
                </div>

                <div className="tarjeta-azul">
                  {j.azules > 0 && (
                    <div>
                      {!errorAzules ? (
                        <Image
                          src={'/img/tarjeta_azul.png'}
                          onError={() => {
                            setErrorAzules(true);
                          }}
                          imageFit={ImageFit.cover}
                          styles={{
                            root: {
                              width: '12px',
                              height: '14px',
                              display: 'inline-block',
                              marginRight: '3px',
                            },
                          }}
                        ></Image>
                      ) : (
                        <Text variant="small">TAz</Text>
                      )}
                    </div>
                  )}
                </div>

                <div className="dos-minutos" style={{ cursor: 'pointer' }}>
                  {form.getTiempoRestanteExclusionXJugador(j.ppj_id, getMinuto()) &&
                    !esDiferido &&
                    !props.onRefereeReview && (
                      <div>
                        <Text
                          styles={{
                            root: {
                              fontSize: '20px',
                              fontWeight: 600,
                            },
                          }}
                          className="exclusion-activa-timer"
                        >
                          {form.getTiempoRestanteExclusionXJugador(j.ppj_id, getMinuto())}
                        </Text>
                      </div>
                    )}
                </div>
              </div>
              <div
                className={
                  form.getTiempoRestanteExclusionXJugador(j.ppj_id, getMinuto()) &&
                  !esDiferido &&
                  !props.onRefereeReview
                    ? 'box-player-planilla text-center clickable ms-depth-4 exclusion-active'
                    : 'box-player-planilla text-center clickable ms-depth-4'
                }
              >
                <div>
                  <div className={j.dorsal.length > 1 ? 'doble-dorsal-planilla' : 'dorsal-planilla'}>
                    {j.dorsal}
                  </div>
                  <Icon style={{ fontSize: '6vw', color: color }} iconName="Shirt"></Icon>
                </div>
                <div style={{ margin: '0 auto', width: '90%' }}>
                  <div className="text-overflow" style={{ fontWeight: 500, fontSize: 12 }}>
                    {j.jug_nombre}
                  </div>
                </div>
                <div
                  className="mt-1"
                  style={
                    j.azules > 0
                      ? { fontWeight: 500, borderTop: '1px solid lightgray', backgroundColor: '#78aef0' }
                      : j.rojas > 0
                      ? { fontWeight: 500, borderTop: '1px solid lightgray', backgroundColor: '#f07878' }
                      : { fontWeight: 500, borderTop: '1px solid lightgray' }
                  }
                >
                  <div
                    className="mt-1"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '0 3px',
                    }}
                  >
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      {!errorGoles ? (
                        <Image
                          src={'/img/gol_2.png'}
                          onError={() => {
                            setErrorGoles(true);
                          }}
                          imageFit={ImageFit.cover}
                          styles={{
                            root: {
                              width: '12px',
                              height: '14px',
                              display: 'inline-block',
                              marginRight: '3px',
                            },
                          }}
                        ></Image>
                      ) : (
                        <Text variant="small">G: </Text>
                      )}

                      {j.goles}
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      {j.amarillas > 0 && (
                        <div>
                          {!errorAmarillas ? (
                            <Image
                              src={'/img/tarjeta_amarilla.png'}
                              onError={() => setErrorAmarillas(true)}
                              imageFit={ImageFit.cover}
                              styles={{
                                root: {
                                  width: '12px',
                                  height: '14px',
                                  display: 'inline-block',
                                  marginRight: '3px',
                                },
                              }}
                            ></Image>
                          ) : (
                            <Text variant="small">TAm: 1</Text>
                          )}

                          {/* {j.amarillas} */}
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      {j.suspensiones > 0 && (
                        <>
                          {!errorSuspensiones ? (
                            <Image
                              src={'/img/dos_minutos.png'}
                              onError={() => {
                                setErrorSuspensiones(true);
                              }}
                              imageFit={ImageFit.cover}
                              styles={{
                                root: {
                                  width: '12px',
                                  height: '14px',
                                  display: 'inline-block',
                                  marginRight: '3px',
                                },
                              }}
                            ></Image>
                          ) : (
                            <Text variant="small">2M: </Text>
                          )}

                          {j.suspensiones}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanillaDigitalJugadoresGrid;
